// src/format.ts
function formatDateDe(iso) {
  const [y, m, d] = iso.split("-");
  return `${d}.${m}.${y}`;
}
function parseDateDe(text) {
  const t = text.trim();
  if (t === "") return "";
  const m = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec(t);
  if (!m) return null;
  const [, d, mo, y] = m;
  const day = Number(d);
  const month = Number(mo);
  if (month < 1 || month > 12 || day < 1 || day > 31) return null;
  return `${y}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}
function formatQuantityDe(quantity) {
  const n = Number(quantity);
  const hasFraction = Math.abs(n % 1) > 0;
  return n.toLocaleString("de-DE", {
    minimumFractionDigits: 0,
    maximumFractionDigits: hasFraction ? 3 : 0
  });
}
function formatQuantity3De(quantity) {
  return Number(quantity).toLocaleString("de-DE", {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3
  });
}
function formatTimestampDateDe(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const fmt = new Intl.DateTimeFormat("de-DE", {
    timeZone: "Europe/Berlin",
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
  });
  const parts = Object.fromEntries(fmt.formatToParts(d).map((p) => [p.type, p.value]));
  return `${parts.day}.${parts.month}.${parts.year}`;
}
function formatDateTimeDe(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const fmt = new Intl.DateTimeFormat("de-DE", {
    timeZone: "Europe/Berlin",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  });
  const parts = Object.fromEntries(fmt.formatToParts(d).map((p) => [p.type, p.value]));
  return `${parts.day}.${parts.month}.${parts.year}, ${parts.hour}:${parts.minute}`;
}
function formatAmountDe(cents) {
  const negative = cents < 0;
  const abs = Math.abs(cents);
  const euros = Math.trunc(abs / 100);
  const rest = (abs % 100).toString().padStart(2, "0");
  const grouped = euros.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${negative ? "-" : ""}${grouped},${rest}`;
}
function formatCentsDe(cents, withSymbol = true) {
  const body = formatAmountDe(cents);
  return withSymbol ? `${body} \u20AC` : body;
}
function parseQuantityDe(text) {
  const t = text.trim().replace(",", ".");
  return /^\d{1,9}(\.\d{1,3})?$/.test(t) ? t : null;
}

export {
  formatDateDe,
  parseDateDe,
  formatQuantityDe,
  formatQuantity3De,
  formatTimestampDateDe,
  formatDateTimeDe,
  formatAmountDe,
  formatCentsDe,
  parseQuantityDe
};
//# sourceMappingURL=chunk-WPMZB3HN.js.map